import React, { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import PostCard from "components/PostCard";
import Link from "ui/Link";
import Reveal from "ui/Reveal";
import moment from "moment";

import { PostsBlockWrapper, Title, PostsGrid } from "./styles/PostsBlockStyles";

const PostsBlock = ({ publicationsList }) => {
  const { navigateTo, currentLang } = useContext(GlobalContext);
  const latestPosts = publicationsList
    ? publicationsList
        .sort(
          (a, b) =>
            moment(b.date).format("YYYYMMDD") -
            moment(a.date).format("YYYYMMDD")
        )
        .filter((a) => a.publications.global.miseEnAvantHome === "oui")
        .slice(0, 4)
    : null;
  return (
    <React.Fragment>
      <PostsBlockWrapper className="posts-block">
        <div className="fixed-container">
          <Reveal>
            <Title>{currentLang === "en" ? "Posts" : "Publications"}</Title>
          </Reveal>
          <PostsGrid>
            {latestPosts &&
              latestPosts.map((publication, i) => (
                <PostCard
                  key={publication.id}
                  data={publication}
                  revealDelay={(i % 2) * 140}
                />
              ))}
          </PostsGrid>
          <Link
            label={
              currentLang === "en"
                ? "Read all posts"
                : "Lire toutes nos publications"
            }
            onClick={() => navigateTo("/publications")}
          />
        </div>
      </PostsBlockWrapper>
    </React.Fragment>
  );
};

PostsBlock.propTypes = {};

PostsBlock.defaultProps = {};

export default PostsBlock;
